/**
 * Unified Archive AJAX Pagination
 *
 * Reusable pagination handler for all archive pages
 * Loads new content via AJAX while maintaining URL structure
 *
 * Usage: Add data attributes to your archive container:
 * - data-ajax-pagination="true" on the main archive wrapper
 * - data-archive-container="#content-id" - ID of container to replace
 * - data-archive-pagination="#pagination-id" - ID of pagination element
 * - data-archive-loading="#loading-id" - ID of loading indicator (optional)
 * - data-scroll-offset="120" - Offset for scroll position (optional, default: 100)
 */

(function ($) {
  'use strict';

  // Configuration
  const config = {
    defaultScrollOffset: 100,
    scrollDuration: 300,
    fadeSpeed: 150
  };

  /**
   * Initialize AJAX pagination for an archive
   */
  function initArchivePagination($archive) {
    const containerId = $archive.data('archive-container');
    const paginationId = $archive.data('archive-pagination');
    const loadingId = $archive.data('archive-loading');
    const scrollOffset = $archive.data('scroll-offset') || config.defaultScrollOffset;

    if (!containerId || !paginationId) {
      console.warn('Archive pagination missing required data attributes');
      return;
    }

    const $container = $(containerId);
    const $pagination = $(paginationId);
    const $loading = loadingId ? $(loadingId) : null;

    // Use event delegation on pagination container
    $pagination.on('click', 'a', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const url = $(this).attr('href');
      if (!url || url === '#' || url === '') {
        return false;
      }

      loadArchivePage(url, {
        $archive,
        $container,
        $pagination,
        $loading,
        scrollOffset
      });

      return false;
    });
  }

  /**
   * Load a new page via AJAX
   */
  function loadArchivePage(url, elements) {
    const { $archive, $container, $pagination, $loading, scrollOffset } = elements;

    // Get the selector strings for finding in response
    const containerSelector = $container.attr('id') ? '#' + $container.attr('id') : $container.selector;
    const paginationSelector = $pagination.attr('id') ? '#' + $pagination.attr('id') : $pagination.selector;

    // Show loading state
    if ($loading && $loading.length) {
      $loading.addClass('active').show();
    }
    $container.css('opacity', '0.5');

    // Perform AJAX request
    $.ajax({
      url: url,
      type: 'GET',
      cache: true,
      success: function (response) {
        try {
          // Parse response
          const $html = $('<div>').html(response);
          const $newContainer = $html.find(containerSelector);
          const $newPagination = $html.find(paginationSelector);

          if ($newContainer.length && $newPagination.length) {
            // Replace content with fade effect
            $container.fadeTo(config.fadeSpeed, 0, function () {
              $container.html($newContainer.html());
              $container.fadeTo(config.fadeSpeed, 1);
            });

            // Replace pagination - keep the wrapper but replace contents
            $pagination.html($newPagination.html());

            // Smooth scroll to archive
            if ($archive.length && $archive.offset()) {
              $('html, body').animate({
                scrollTop: $archive.offset().top - scrollOffset
              }, config.scrollDuration);
            }

            // Update browser URL without reload
            if (window.history && window.history.pushState) {
              window.history.pushState({ page: url }, '', url);
            }

            // Trigger custom event for other scripts
            $(document).trigger('archivePaginationLoaded', [url, $container]);
          } else {
            console.error('Could not find archive content in AJAX response', {
              containerSelector: containerSelector,
              paginationSelector: paginationSelector,
              foundContainer: $newContainer.length,
              foundPagination: $newPagination.length
            });
            fallbackToNormalNavigation(url);
          }
        } catch (error) {
          console.error('Error parsing AJAX response:', error);
          fallbackToNormalNavigation(url);
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX pagination error:', error);
        fallbackToNormalNavigation(url);
      },
      complete: function () {
        // Hide loading state
        if ($loading && $loading.length) {
          $loading.removeClass('active').hide();
        }
        $container.css('opacity', '1');
      }
    });
  }

  /**
   * Fallback to normal page navigation
   */
  function fallbackToNormalNavigation(url) {
    window.location.href = url;
  }

  /**
   * Handle browser back/forward buttons
   */
  function handlePopState() {
    window.addEventListener('popstate', function (event) {
      if (event.state && event.state.page) {
        location.reload(); // Simple reload on back/forward
      }
    });
  }

  /**
   * Initialize all archive pagination on page
   */
  function initAll() {
    $('[data-ajax-pagination="true"]').each(function () {
      initArchivePagination($(this));
    });

    handlePopState();
  }

  // Initialize when DOM is ready
  $(function () {
    initAll();
  });

  // Re-initialize on dynamic content load
  $(document).on('archiveContentUpdated', function () {
    initAll();
  });

})(jQuery);
